import React from 'react';
import { HiOutlineClock } from 'react-icons/hi';
import { useNoteContext } from '@/components/notes/context/NoteContext';

const ToggleVersionsPanelButton: React.FC = () => {
  const { isVersionsPanelOpen, onToggleVersionsPanel } = useNoteContext();

  return (
    <button
      type="button"
      onClick={onToggleVersionsPanel}
      className={`p-2 rounded transition-colors ${
        isVersionsPanelOpen
          ? 'bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100'
          : 'hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-400'
      }`}
      title="Version history"
      aria-label="Toggle version history panel"
      aria-pressed={isVersionsPanelOpen}
    >
      <HiOutlineClock size={18} />
    </button>
  );
};

export default ToggleVersionsPanelButton;

